<app-page heading="Your Prompts">
  @if (roleService.canEdit()) {
    <ng-template pageHeadingButtons>
      <app-button type="new_prompt" [routerLink]="['new']"/>
    </ng-template>
  }

  <div class="scroll-container">
    <app-entity-list [items]="prompts" linked="true"/>
  </div>
</app-page>
